import { mdiArrowLeft } from '@mdi/js';
import { Icon } from 'its-react-ui';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { fetchDocumentsByAgreementContext, reset } from '../../containers/Search';
import useWindowWidth from '../../hooks/useWindowWidth';
import RemoteDataComponent from '../../lib/RemoteData';
import * as constants from '../constVariables';
import Header from '../Header';
import { PageStatus, PageSpinner } from '../Shared';
import Main from '../Shared/Main';
import CaseDocumentSearchBarAgreement from './CaseDocumentSearchBarAgreement';
import CaseDocumentSearchDesktopAgreement from './CaseDocumentSearchDesktopAgreement';
import CaseDocumentSearchMobile from './CaseDocumentSearchMobile';
import styles from './CaseDocumentSearchPageAgreement.module.scss';

const CaseDocumentSearchPageAgreement = () => {
  const {
    caseSearch: { fetchCaseDocumentsState },
  } = useSelector(({ caseSearch }) => ({ caseSearch }));
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { mainAgreementId, productAgreementId } = useParams();

  const goBack = async () => {
    if (location.state && location.state.backUrl) {
      history.push(location.state.backUrl);
    } else {
      dispatch(reset());
      history.push('/');
    }
  };

  useEffect(() => {
    dispatch(fetchDocumentsByAgreementContext(productAgreementId === '0' ? 'Agreement' : 'ProductAgreement', mainAgreementId, productAgreementId));
  }, [dispatch, location.pathname]);
  const width = useWindowWidth();
  // Use custom breakpoint to break earlier to mobile as the table is not usefull on small screens.
  const renderMobileView = width < 1360;

  return (
    <>
      <Header>
        {renderMobileView && (
          <button data-test-id="abc9RhNWUfjLFLYmX3y_U" type="button" className={styles.back} onClick={goBack}>
            <Icon path={mdiArrowLeft} size={constants.ICON_SIZE} color={constants.WHITE} />
          </button>
        )}
      </Header>
      <Main className={styles.content}>
        <CaseDocumentSearchBarAgreement />

        <RemoteDataComponent
          type={fetchCaseDocumentsState}
          loading={() => <PageSpinner />}
          failure={({ status }) => <PageStatus statusCode={status} />}
          success={(_) => (renderMobileView ? <CaseDocumentSearchMobile /> : <CaseDocumentSearchDesktopAgreement />)}
        />
      </Main>
    </>
  );
};

export default CaseDocumentSearchPageAgreement;
